import { create } from 'zustand';
import { apiService } from '../services/api';

interface SubscriptionStatus {
  active: boolean;
  expiresAt: string | null;
}

interface AccountInfo {
  referralCode: string;
  creditBalance: number;
  totalCreditsEarned: number;
  referralCount: number;
  creditUnlockEnabled: boolean;
  subscriptions: Record<string, SubscriptionStatus>; // { sat, ap }
}

interface AccountState {
  account: AccountInfo | null;
  loading: boolean;
  fetchAccount: () => Promise<void>;
  /** 某科目是否有有效订阅 */
  isSubscribed: (plan: 'sat' | 'ap') => boolean;
  /** 某 tab 是否可见：practice 恒可见；sat/ap 需订阅或开启 credit_unlock_enabled */
  canSeeTab: (tab: 'practice' | 'sat' | 'ap') => boolean;
}

export const useAccountStore = create<AccountState>((set, get) => ({
  account: null,
  loading: false,

  fetchAccount: async () => {
    set({ loading: true });
    try {
      const res: any = await apiService.get('/account');
      if (res.success) set({ account: res.data, loading: false });
      else set({ loading: false });
    } catch {
      set({ loading: false });
    }
  },

  isSubscribed: (plan) => {
    const a = get().account;
    return !!a?.subscriptions?.[plan]?.active;
  },

  canSeeTab: (tab) => {
    if (tab === 'practice') return true;
    const a = get().account;
    if (!a) return false;
    return a.creditUnlockEnabled || !!a.subscriptions?.[tab]?.active;
  },
}));
